import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TBaAppDB } from './baapp.reducer';

export const BA_APP_STATE = 'BA_APP_STATE';
export const baAppDB = createFeatureSelector<TBaAppDB>(BA_APP_STATE);

export const getDepartmentList = createSelector(baAppDB, (db) => {
  return db.departmentList;
});

export const getSelectedDepartment = createSelector(baAppDB, (db) => {
  return db.selectedDepartment;
});
